/* istanbul ignore file */

import { MenuItemType } from "@customer-tools-web/component-header-footer";

const GA_BASE = {
  addListing: {
    event_category: "Create Listing",
    event_action: "Create Listing",
    event_source: "Create Listing",
  },
  overview: {
    event_source: "Listing Details",
  },
  myListings: {
    event: "navigation",
    event_category: "Navigation",
    event_source: "My Listings",
  },
  moreAction: {
    event_source: "My Listings",
  },
  listing_search: {
    event: "search",
    event_category: "Search Listing",
    event_action: "Search",
    event_source: "My Listings",
  },
  listingAction: {
    event_source: "My Listings",
  },
  navigation: {
    event: "navigation",
    event_category: "Navigation",
    event_action: "Menu",
    event_source: "Header",
  },
  fsbo: {
    event_source: "FSBO Alerts",
    event_label: "FSBO Alert",
  },
  creditReportingFilter: {
    event: "credit_reporting_filter",
    event_category: "Search Credit Reporting",
    event_action: "Credit Reporting Filter",
    event_source: "Credit Reporting",
  },
  paymentGateway: {
    event: "navigation",
    event_category: "Navigation",
    event_source: "Payment Gateway",
  },
  areaCondoSpecialist: {
    event: "navigation",
    event_category: "Navigation",
    event_source: "Specialist Package",
  },
  leadSearch: {
    event: "search lead",
    event_category: "Search Lead",
    event_action: "Search",
    event_source: "Lead Management",
  },
  leadFilter: {
    event: "filter lead",
    event_category: "Filter Lead",
    event_action: "Filter",
    event_source: "Lead Management",
  },
  leadNavigation: {
    event: "navigation",
    event_category: "Navigation",
    event_action: "Navigation",
    event_source: "Lead Management",
  },
};
export type EventMarketType = "HK" | "MY";

export interface BaseEvent {
  event: string;
  event_category: string;
  event_action: string;
  event_label: string;
  event_source: string;
  market?: EventMarketType[];
}

interface OptionEvent {
  event?: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  event_source?: string;
}

interface CreditUsageOption {
  credit_reporting_activities?: string;
  credit_reporting_credit_type?: string;
  credit_reporting_search_listingid?: string;
}

interface SelfServeOption {
  isCreditBrickz?: boolean;
}

interface AreaCondoSpecialistOption {
  isCondo?: boolean;
  areaCondoName?: string;
}

type GAOptions = OptionEvent &
  CreditUsageOption &
  SelfServeOption &
  AreaCondoSpecialistOption;

export const GA: {
  [Section in string]: {
    [Action in string]: (options?: GAOptions) => BaseEvent;
  };
} = {
  addListing: {
    "Tap/Click on Save and Continue": (options) => ({
      ...GA_BASE.addListing,
      event: "create_next",
      event_action: "Save and Continue",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Back": (options) => ({
      ...GA_BASE.addListing,
      event: "create_back",
      event_action: "Back",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Listings tab on top to exit creation": (option) => ({
      ...GA_BASE.addListing,
      event: "create_exit",
      event_action: "Exit via Tab",
      event_label: "(not set)",
      market: ["HK"],
      ...option,
    }),
    "Tap on Cancel button to exit creation": () => ({
      ...GA_BASE.addListing,
      event: "create_exit",
      event_action: "Exit via Cancel",
      event_label: "Step 1 - Listing Type",
    }),
    "Tap on Save Draft & Exit to exit creation": (options) => ({
      ...GA_BASE.addListing,
      event: "create_exit",
      event_action: "Exit via Save Draft",
      event_label: "(not set)",
      market: ["HK"],
      ...options,
    }),
    "Tap/Click on Save draft and exit": (options) => ({
      ...GA_BASE.addListing,
      event: "create_exit",
      event_action: "Exit via Save draft and exit",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
    "Tap on View Upload Requirements": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "View Upload Requirements",
    }),
    "Tap on Image Drag Icon": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Image Drag Icon",
    }),
    "Tap on View Details on Image Upload Error box": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "View Details on Image Upload Error",
    }),
    "Tap on Rotate Image": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Rotate Image",
    }),
    "Tap/Click on Select Photos": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Select Images",
      market: ["MY"],
    }),
    "Tap/Click to deleted selected images": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Delete Selected Images",
      market: ["MY"],
    }),
    "Tap/Click to select all images": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Select All Images",
      market: ["MY"],
    }),
    "Tap/Click x to deleted image": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Delete Image",
      market: ["MY"],
    }),
    "Tap/Click on images": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Image Click",
      market: ["MY"],
    }),
    "Tap/Click on Save edited image": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Save Edited Image",
      market: ["MY"],
    }),
    "Tap/Click x to close edit image screen": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Close Edit Image",
      market: ["MY"],
    }),
    "Tap on Add Image": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Add Image",
    }),
    "Tap on Add Floor Plan": () => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "Add Floor Plan",
    }),
    "Tap on Upgrade Tooltip": (options) => ({
      ...GA_BASE.addListing,
      event: "navigation",
      event_category: "Navigation",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Step Navigator": (options) => ({
      ...GA_BASE.addListing,
      event: "create_skip",
      event_action: "Skip to Step",
      event_label: "(not set)",
      ...options,
    }),
    "Turn on Auto Upgrade radio button": (options) => ({
      ...GA_BASE.addListing,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Intent",
      event_label: "(not set)",
      ...options,
    }),
    "On Success Auto Upgrade": (options) => ({
      ...GA_BASE.addListing,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Publish": (options) => ({
      ...GA_BASE.addListing,
      event: "create_publish",
      event_action: "Publish Intent",
      event_label: "(not set)",
      ...options,
    }),
    "On Success": (options) => ({
      ...GA_BASE.addListing,
      event: "create_publish_success",
      event_action: "Publish Success",
      event_label: "(not set)",
      ...options,
    }),
    "On Failure": (options) => ({
      ...GA_BASE.addListing,
      event: "create_publish_fail",
      event_action: "Publish Fail",
      event_label: "(not set)",
      ...options,
    }),
  },
  overview: {
    "When results appear": () => ({
      ...GA_BASE.overview,
      event: "view_item",
      event_category: "View Listing",
      event_action: "View Item",
      event_label: "Listing Details Overview",
    }),
    "Tap on Overview Tab": () => ({
      ...GA_BASE.overview,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Details",
      event_label: "Listing Details Overview",
    }),
    "Tap on Reporting Tab": () => ({
      ...GA_BASE.overview,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Details",
      event_label: "Listing Details Reporting",
    }),
    "Tap on Edit": (options) => ({
      ...GA_BASE.overview,
      event: "edit",
      event_category: "Edit Listing",
      event_action: "Intent",
      event_label: "(not set)",
      ...options,
    }),
    "On Success Edit": (options) => ({
      ...GA_BASE.overview,
      event: "edit",
      event_category: "Edit Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Delete on Expired listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Expired Listing",
    }),
    "On Success Delete on Expired listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Expired Listing",
    }),
    "Tap on Delete on Draft listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Draft Listing",
    }),
    "On Success Delete on Draft listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Draft Listing",
    }),
    "Click/tap on Readvertise Listings": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On Success Readvertise Listings": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
    "Tap on Cancel Auto Upgrade": () => ({
      ...GA_BASE.overview,
      event: "automate_upgrade",
      event_category: "Cancel Upgrade Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "Turn on Auto Upgrade radio button": (options) => ({
      ...GA_BASE.overview,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Intent",
      event_label: "(not set)",
      ...options,
    }),
    "On Success Auto Upgrade": (options) => ({
      ...GA_BASE.overview,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
    }),
    "On Success Cancel Auto Upgrade": () => ({
      ...GA_BASE.overview,
      event: "automate_upgrade",
      event_category: "Cancel Upgrade Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
    "Click/tap Upgrade": (options) => ({
      ...GA_BASE.overview,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Intent",
      event_label: "(not set)",
      ...options,
    }),
    "On Success Upgrade": (options) => ({
      ...GA_BASE.overview,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
    }),
    "Click/tap Extend listing expiry": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "extend",
      event_category: "Extend Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On Success Extend listing expiry": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "extend",
      event_category: "Extend Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
    "Click/tap Take Property Offline": () => ({
      ...GA_BASE.overview,
      event: "take_offline",
      event_category: "Take Offline Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On Success Take Property Offline": () => ({
      ...GA_BASE.overview,
      event: "take_offline",
      event_category: "Take Offline Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
    "Click/tap Copy on Online listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On Success Copy on Online listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
    "Click/Tap on 'Share'": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "social_share",
      event_category: "Share Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On selected Social Media": (options) => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "social_share",
      event_category: "Share Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
    }),
    "Tap on Reactivate on Offline listing": () => ({
      ...GA_BASE.overview,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Offline Listing",
    }),
    "On Success Reactivate on Offline listing": () => ({
      ...GA_BASE.overview,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Offline Listing",
    }),
    "Click/tap Copy on Offline listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Intent",
      event_label: "Offline Listing",
    }),
    "On Success Copy on Offline listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Success",
      event_label: "Offline Listing",
    }),
    "Tap on Delete on Offline listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Offline Listing",
    }),
    "On Success Delete on Offline listing": () => ({
      ...GA_BASE.overview,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Offline Listing",
    }),
    "Tap on Reactivate on Expired listing": () => ({
      ...GA_BASE.overview,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Expired Listing",
    }),
    "On Success Reactivate on Expired listing": () => ({
      ...GA_BASE.overview,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Expired Listing",
    }),
    "Click/tap Copy on Expired listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Intent",
      event_label: "Expired Listing",
    }),
    "On Success Copy on Expired listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Success",
      event_label: "Expired Listing",
    }),
    "Click/tap Download listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "download",
      event_category: "Download Listing",
      event_action: "Intent",
      event_label: "Online Listing",
    }),
    "On Success Download listing": () => ({
      ...GA_BASE.overview,
      market: ["MY"],
      event: "download",
      event_category: "Download Listing",
      event_action: "Success",
      event_label: "Online Listing",
    }),
  },
  myListings: {
    "When results appear": () => ({
      event: "view_search_results",
      event_category: "Search Listing",
      event_action: "View Search Results",
      event_source: "My Listings",
      event_label: "(not set)",
    }),
    "Tap on button to launch Filters popup": () => ({
      ...GA_BASE.myListings,
      event_action: "Search Listing",
      event_label: "Filters Popup",
    }),
    "click on 'Create listing' button to add a listing": () => ({
      ...GA_BASE.myListings,
      event_action: "Create Listing",
      event_label: "Add a Property Tab",
    }),
    "Tap on More Action": () => ({
      ...GA_BASE.myListings,
      event_action: "Other Action",
      event_label: "More Actions",
    }),
    "Click/tap on 'Online' tab": () => ({
      ...GA_BASE.listing_search,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Tabs",
      event_label: "Online",
      market: ["MY"],
    }),
    "Click/tap on 'Draft' tab": () => ({
      ...GA_BASE.listing_search,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Tabs",
      event_label: "Draft",
      market: ["MY"],
    }),
    "Click/tap on 'Offline' tab": () => ({
      ...GA_BASE.listing_search,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Tabs",
      event_label: "Offline",
      market: ["MY"],
    }),
    "Click/tap on 'Expired' tab": () => ({
      ...GA_BASE.listing_search,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Tabs",
      event_label: "Expired",
      market: ["MY"],
    }),
    "When user click on the layout option": (options) => ({
      ...GA_BASE.listing_search,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Listing Layout",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
  },
  moreAction: {
    "trigger this event on click/tap on readvertise Listings(online)": () => ({
      ...GA_BASE.moreAction,
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Intent",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "On Success Readvertise Listings.": () => ({
      ...GA_BASE.moreAction,
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on schedule Listings(online)": () => ({
      ...GA_BASE.moreAction,
      event: "schedule_readvertise",
      event_category: "Schedule Readvertisement Listing",
      event_action: "Intent",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "On Success Schedule Readvertisement": () => ({
      ...GA_BASE.moreAction,
      event: "schedule_readvertise",
      event_category: "Schedule Readvertisement Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on upgrade_to_feature_7 Listings(online)":
      () => ({
        ...GA_BASE.moreAction,
        event: "upgrade",
        event_category: "Upgrade Listing",
        event_action: "Intent",
        event_label: "(not set)",
        event_source: "My Listings - Featured 7 Days",
        market: ["MY"],
      }),
    "On Success Upgrade to Featured 7 Days": () => ({
      ...GA_BASE.moreAction,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Success",
      event_label: "Featured",
      event_source: "My Listings - Featured 7 Days",
      market: ["MY"],
    }),
    "On Success Upgrade to Featured 7 Days (Auto Upgraded Enabled)": () => ({
      ...GA_BASE.moreAction,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      event_source: "My Listings - Featured 7 Days",
      market: ["MY"],
    }),
    "trigger this event on click/tap on upgrade_to_feature_28 Listings(online)":
      () => ({
        ...GA_BASE.moreAction,
        event: "upgrade",
        event_category: "Upgrade Listing",
        event_action: "Intent",
        event_label: "(not set)",
        event_source: "My Listings - Featured 28 Days",
        market: ["MY"],
      }),
    "On Success Upgrade to Featured 28 Days": () => ({
      ...GA_BASE.moreAction,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Success",
      event_label: "Featured",
      event_source: "My Listings - Featured 28 Days",
      market: ["MY"],
    }),
    "On Success Upgrade to Featured 28 Days (Auto Upgraded Enabled)": () => ({
      ...GA_BASE.moreAction,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      event_source: "My Listings - Featured 28 Days",
      market: ["MY"],
    }),
    "trigger this event on click/tap on offline Listings(online)": () => ({
      ...GA_BASE.moreAction,
      event: "take_offline",
      event_category: "Take Offline Listing",
      event_action: "Intent",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "On success Take Listings Offline": () => ({
      ...GA_BASE.moreAction,
      event: "take_offline",
      event_category: "Take Offline Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on export Listings(online)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Intent",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "Trigger on success export(online)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Success",
      event_label: "Online Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on delete Listings(draft)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Draft Bulk Action",
      market: ["MY"],
    }),
    "On Success Delete listings(draft)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Draft Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on reactivate Listings(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "On Success Reactivate(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on export Listings(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Intent",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "Trigger on success export(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Success",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on delete Listings(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "On Success Delete listings(offline)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Offline Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on delete Listings(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "On Success Delete listings(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on republish Listings(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "On Success Reactivate(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "trigger this event on click/tap on export Listings(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Intent",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "Trigger on success export(expired)": () => ({
      ...GA_BASE.moreAction,
      event: "export",
      event_category: "Export Listing",
      event_action: "Success",
      event_label: "Expired Bulk Action",
      market: ["MY"],
    }),
    "Tap on Batch upload": () => ({
      ...GA_BASE.myListings,
      event_action: "Other Action",
      event_label: "Batch Upload",
      market: ["HK"],
    }),
  },
  listing_search: {
    "Trigger on Search via Text Field (Free Text)": () => ({
      ...GA_BASE.listing_search,
      event_label: "Free Text Keyword",
      market: ["MY"],
    }),
    "Trigger on Search via Text Field (Auto Suggest)": () => ({
      ...GA_BASE.listing_search,
      event_label: "Auto Suggest Keyword",
      market: ["MY"],
    }),
    "Trigger on Search via Delete Field": () => ({
      ...GA_BASE.listing_search,
      event_label: "Remove Keyword",
      market: ["MY"],
    }),
    'Click on "Clear" under Filter': () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "Remove All Filter",
      market: ["MY"],
    }),
    "Trigger on tap of 'Filter' button in filter screen (conversion)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Click Filter Button",
      market: ["MY"],
    }),
    "Click/tap of 'Listing Type' drop down (not on selected) (intent)(web view)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Click Listing Type Drop Down Menu",
        market: ["MY"],
      }),
    "Click/tap 'Buy' or 'Rent' button (ListingType) (conversion)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Click Listing Type Button",
      market: ["MY"],
    }),
    "Click/tap of 'Category Type' drop down (not on selected) (intent)(web view)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Click Category Type Drop Down Menu",
        market: ["MY"],
      }),
    "Tap/Click on 'Residential' or 'Commercial' button (Category Type) (conversion)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Click Category Type Button",
        market: ["MY"],
      }),
    "Click/tap of 'Auto-upgrade' drop down (not on selected) (intent)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Click Upgrade Automation Type Drop Dropdown Menu",
    }),
    "Trigger on selected 'Auto-upgrade' drop down (on selected/conversion)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Selected Upgrade Automation Type Drop Dropdown Menu",
      }),
    "Click/tap of 'Property Type' drop down (not on selected) (intent)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Click Property Type Drop Down Menu",
        market: ["MY"],
      }),
    "Trigger on selected 'Property Type' drop down (on selected/conversion)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Selected Property Type Drop Down Menu",
        market: ["MY"],
      }),
    "Click/tap of 'Listing Upgrade' drop down (not on selected) (intent)":
      () => ({
        ...GA_BASE.listing_search,
        event: "filter",
        event_action: "Filter",
        event_label: "On Click Tier Drop Dropdown Menu",
        market: ["MY"],
      }),
    "Trigger  on selected 'Listing Upgrade' drop down (conversion)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Selected Tier Drop Dropdown Menu",
      market: ["MY"],
    }),
    "Click/tap of 'Unit Type' drop down (not on selected) (intent)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Click Unit Type Dropdown Menu",
      market: ["MY"],
    }),
    "Trigger on selected 'Unit Type' drop down (conversion)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Selected Unit Type Dropdown Menu",
      market: ["MY"],
    }),
    "Click/tap of 'Price Range' drop down (not on selected) (intent)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Click Price Range Dropdown Menu",
      market: ["MY"],
    }),
    "Trigger on key in 'Price Range' fields (conversion)": () => ({
      ...GA_BASE.listing_search,
      event: "filter",
      event_action: "Filter",
      event_label: "On Key In Price Range",
      market: ["MY"],
    }),
    "Click/tap of 'Sort' drop down (not on selected) (intent)": () => ({
      ...GA_BASE.listing_search,
      event: "sort",
      event_action: "Sort",
      event_label: "On Click Sort Drop Down Menu",
      market: ["MY"],
    }),
    "Trigger on selected Sort option (conversion)": (options) => ({
      ...GA_BASE.listing_search,
      event: "sort",
      event_action: "Sort",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
  },
  listingAction: {
    "Tap/Click on listing via thumbnail(online)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Thumbnail",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via thumbnail(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Thumbnail",
      event_label: "Draft Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via thumbnail(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Thumbnail",
      event_label: "Offline Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via thumbnail(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Thumbnail",
      event_label: "Expired Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via title(online)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Title",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via title(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Title",
      event_label: "Draft Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via title(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Title",
      event_label: "Offline Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via title(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Title",
      event_label: "Expired Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via link(online)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Link",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via link(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Link",
      event_label: "Draft Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via link(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Link",
      event_label: "Offline Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via link(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Link",
      event_label: "Expired Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via area(online)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Area",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via area(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Area",
      event_label: "Draft Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via area(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Area",
      event_label: "Offline Listing",
      market: ["MY"],
    }),
    "Tap/Click on listing via area(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "list_click",
      event_category: "Listing Click",
      event_action: "Area",
      event_label: "Expired Listing",
      market: ["MY"],
    }),
    "Tap on Upgrade": () => ({
      ...GA_BASE.listingAction,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Intent",
      event_label: "(not set)",
      market: ["MY"],
    }),
    "Tap on Reactivate on Offline listing(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Offline Listing",
      market: ["MY"],
    }),
    "Tap on Reactivate on Offline listing(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Intent",
      event_label: "Expired Listing",
      market: ["MY"],
    }),
    "On Success Upgrade": (options) => ({
      ...GA_BASE.listingAction,
      event: "upgrade",
      event_category: "Upgrade Listing",
      event_action: "Success",
      event_label: "(not set)",
      ...options,
      market: ["MY"],
    }),
    "Turn on Auto Upgrade radio button": (options) => ({
      ...GA_BASE.listingAction,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Intent",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
    "On Success Auto Upgrade": (options) => ({
      ...GA_BASE.listingAction,
      event: "automate_upgrade",
      event_category: "Auto Upgrade Listing",
      event_action: "Success",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
    "Tap on Readvertise": () => ({
      ...GA_BASE.listingAction,
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Intent",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "On Success Readvertise": () => ({
      ...GA_BASE.listingAction,
      event: "readvertise",
      event_category: "Readvertise Listing",
      event_action: "Success",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap on '...' on listing card": () => ({
      ...GA_BASE.listingAction,
      event: "navigation",
      event_category: "Navigation",
      event_action: "Other Action",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap on Cancel Auto Upgrade": () => ({
      ...GA_BASE.listingAction,
      event: "automate_upgrade",
      event_category: "Cancel Upgrade Listing",
      event_action: "Intent",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "On Success Cancel Auto Upgrade": () => ({
      ...GA_BASE.listingAction,
      event: "automate_upgrade",
      event_category: "Cancel Upgrade Listing",
      event_action: "Success",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap on Extend listing expiry": () => ({
      ...GA_BASE.listingAction,
      event: "extend",
      event_category: "Extend Listing",
      event_action: "Intent",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "On Success Extend listing expiry": () => ({
      ...GA_BASE.listingAction,
      event: "extend",
      event_category: "Extend Listing",
      event_action: "Success",
      event_label: "Online Listing",
      market: ["MY"],
    }),
    "Tap on Delete listing(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Draft Listing",
    }),
    "On Success Delete listing(draft)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Draft Listing",
    }),
    "Tap on Copy on Draft listing": () => ({
      ...GA_BASE.listingAction,
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Intent",
      event_label: "Draft Listing",
    }),
    "On Success Copy on Draft listing": () => ({
      ...GA_BASE.listingAction,
      event: "copy",
      event_category: "Copy Listing",
      event_action: "Success",
      event_label: "Draft Listing",
    }),
    "Tap on Delete listing(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Offline Listing",
    }),
    "On Success Delete listing(offline)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Offline Listing",
    }),
    "Tap on Delete listing(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Intent",
      event_label: "Expired Listing",
    }),
    "On Success Delete listing(expired)": () => ({
      ...GA_BASE.listingAction,
      event: "delete",
      event_category: "Delete Listing",
      event_action: "Success",
      event_label: "Expired Listing",
    }),
    "On Success Reactivate on Offline listing": () => ({
      ...GA_BASE.listingAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Offline Listing",
    }),
    "On Success Reactivate on Expired listing": () => ({
      ...GA_BASE.listingAction,
      event: "reactivate",
      event_category: "Reactivate Listing",
      event_action: "Success",
      event_label: "Expired Listing",
    }),
  },
  navigation: {
    "Click on Dashboard": () => ({
      ...GA_BASE.navigation,
      event_label: "Dashboard",
      market: ["MY"],
    }),
    "Click on 'Listings Management'": () => ({
      ...GA_BASE.navigation,
      event_label: "Listing Management",
      market: ["MY"],
    }),
    "Click on 'Scheduled Readvertising Manager'": () => ({
      ...GA_BASE.navigation,
      event_label: "Scheduled Readvertising Manager",
      market: ["MY"],
    }),
    "Click on 'Watermark Settings'": () => ({
      ...GA_BASE.navigation,
      event_label: "Watermark Settings",
      market: ["MY"],
    }),
    "Click on 'Agent Listing Report'": () => ({
      ...GA_BASE.navigation,
      event_label: "Agent Listing Report",
      market: ["MY"],
    }),
    "Click on Market Analytics": () => ({
      ...GA_BASE.navigation,
      event_label: "Market Analytics",
      market: ["MY"],
    }),
    "Click on MarketWatch": () => ({
      ...GA_BASE.navigation,
      event_label: "MarketWatch",
      market: ["MY"],
    }),
    "Click on 'Leads'": () => ({
      ...GA_BASE.navigation,
      event_label: "Leads",
      market: ["MY"],
    }),
    "Header Tap on My Profile": () => ({
      ...GA_BASE.navigation,
      event_label: "My Profile",
    }),
    "Header Tap on Subscriptions": () => ({
      ...GA_BASE.navigation,
      event_label: "Subscriptions",
    }),
    "Header Tap on My Team": () => ({
      ...GA_BASE.navigation,
      event_label: "My Team",
    }),
    "Header Tap on CC Enquiry": () => ({
      ...GA_BASE.navigation,
      event_label: "CC Enquiry",
    }),
    "Header Tap on Account Settings": () => ({
      ...GA_BASE.navigation,
      event_label: "Account Settings",
    }),
    "Header Tap on Log Out": () => ({
      ...GA_BASE.navigation,
      event_label: "Log Out",
    }),
    "Header Tap on Allocations": () => ({
      ...GA_BASE.navigation,
      event_label: "Allocations",
    }),
    "Header Tap on Enquiry settings": () => ({
      ...GA_BASE.navigation,
      event_label: "Enquiry Settings",
    }),
    "Header Tap on Change Language": () => ({
      ...GA_BASE.navigation,
      event_label: "Language",
    }),
    "Header Tap on Agency/Branch management": () => ({
      ...GA_BASE.navigation,
      event_label: "Agency/Branch Management",
    }),
    "Link to consumer site SF": () => ({
      ...GA_BASE.navigation,
      event_label: "Open squarefoot.com.hk",
    }),
    "Link to consumer site MY": () => ({
      ...GA_BASE.navigation,
      event_label: "Open iproperty.com.my",
      market: ["MY"],
    }),
    "Click on 'Search Properties'": () => ({
      ...GA_BASE.navigation,
      event_label: "Search Properties",
      market: ["MY"],
    }),
    "Click on 'Property Wanted'": () => ({
      ...GA_BASE.navigation,
      event_label: "Property Wanted",
      market: ["MY"],
    }),
    "Click on 'FSBO Alerts'": () => ({
      ...GA_BASE.navigation,
      event_label: "FSBO Alerts",
      market: ["MY"],
    }),
    "Link to Home Report": () => ({
      ...GA_BASE.navigation,
      event_label: "Open iPropertyiQ",
      market: ["MY"],
    }),
    "Link to Brickz": () => ({
      ...GA_BASE.navigation,
      event_label: "Open Brickz",
      market: ["MY"],
    }),
    "Survey Submit Intent": (options) => ({
      ...GA_BASE.navigation,
      event: "survey_submission",
      event_action: "Survey Submit Intent",
      event_source: "Create Listing",
      event_label: "(not set)",
      ...options,
    }),
    "Survey Submit Success": (options) => ({
      ...GA_BASE.navigation,
      event: "survey_submission",
      event_action: "Survey Submit Success",
      event_source: "Create Listing",
      event_label: "(not set)",
      ...options,
    }),
    "Click on Credit Usage History": () => ({
      ...GA_BASE.navigation,
      event_action: "Subscription",
      event_label: "Credit Usage History",
      event_source: "Subscription",
      market: ["MY"],
    }),
    "Click on Dashboard 'Upgrade Now'": () => ({
      ...GA_BASE.navigation,
      event_action: "Dashboard",
      event_label: "Upgrade Now",
      event_source: "Specialist Package",
      market: ["MY"],
    }),
    "Click on Dashboard 'View Package'": () => ({
      ...GA_BASE.navigation,
      event_action: "Dashboard",
      event_label: "View Package",
      event_source: "Specialist Package",
      market: ["MY"],
    }),
    "Click on Subscription 'Upgrade Now'": () => ({
      ...GA_BASE.navigation,
      event_action: "Subscription",
      event_label: "Upgrade Now",
      event_source: "Specialist Package",
      market: ["MY"],
    }),
    "Click on Area/Condo Specialist Area or Condo Name": (options) => ({
      ...GA_BASE.navigation,
      event_action: "Area Condo Specialist",
      event_source: "Specialist Package",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
    "Click on Area/Condo Specialist Current Listing": (options) => ({
      ...GA_BASE.navigation,
      event_action: "Area Condo Specialist",
      event_source: "Specialist Package",
      event_label: "(not set)",
      market: ["MY"],
      ...options,
    }),
    "Click on 'Buy'": () => ({
      ...GA_BASE.navigation,
      event_label: "Buy",
    }),
    "Header Tap on 'Payment History'": () => ({
      ...GA_BASE.navigation,
      event_action: "View Payment History",
      event_label: "Header",
      event_source: "Payment Gateway",
    }),
    "Click on 'Area Condo Specialist' at Listing Header": () => ({
      ...GA_BASE.navigation,
      event_label: "Area & Condo Specialist",
    }),
    "Click on Dashboard 'Book now' at Area Condo Specialist Package": () => ({
      ...GA_BASE.navigation,
      event_action: "Dashboard",
      event_label: "Book now",
      event_source: "Specialist Package",
    }),
    "Click on Dashboard 'View all packages' at Area & Condo Specialist Packages Section":
      () => ({
        ...GA_BASE.navigation,
        event_action: "Dashboard",
        event_label: "View Package",
        event_source: "Specialist Package",
      }),
  },
  fsbo: {
    "Click on 'Create an alert' button": () => ({
      ...GA_BASE.fsbo,
      event: "create_alert",
      event_category: "Create Alert",
      event_action: "Intent",
    }),
    "On success alert creation": () => ({
      ...GA_BASE.fsbo,
      event: "create_alert",
      event_category: "Create Alert",
      event_action: "Success",
    }),
    "Click on 'Actions' button": () => ({
      ...GA_BASE.fsbo,
      event: "delete_alert",
      event_category: "Delete Alert",
      event_action: "Intent",
    }),
    "On success alert deletion": () => ({
      ...GA_BASE.fsbo,
      event: "delete_alert",
      event_category: "Delete Alert",
      event_action: "Success",
    }),
  },
  creditReportingFilter: {
    "When user click Activities": (options) => ({
      ...GA_BASE.creditReportingFilter,
      ...options,
      event_label: "On Click Activities",
    }),
    "When user click Credit Type": (options) => ({
      ...GA_BASE.creditReportingFilter,
      ...options,
      event_label: "On Click Credit Type",
    }),
    "Trigger on key in 'Search Listing Id' fields (conversion)": (options) => ({
      ...GA_BASE.creditReportingFilter,
      ...options,
      event_label: "On Key In Listing Id",
    }),
  },
  paymentGateway: {
    "Click on Subscription 'Renew Online'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Subscription",
      event_label: "Renew Online",
    }),
    "Click on Subscription 'Buy Credits'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Subscription",
      event_label: "Buy Credits",
    }),
    "Click on Subscription 'Buy Brickz'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Subscription",
      event_label: "Buy Brickz",
    }),
    "Click on 'Credit Packages'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Buy View Add on",
      event_label: "Credits Packages",
    }),
    "Click on 'Brickz'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Buy View Add on",
      event_label: "Brickz Packages",
    }),
    "Click on 'Apply' at Promo Code": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Intent" : "Renewal Intent",
      event_label: "Apply Promo Code (not set)",
      ...options,
    }),
    "Click on 'Purchase'": (options) => ({
      event: "navigation",
      event_category: "Navigation",
      event_action: options?.isCreditBrickz
        ? "Credit & Brickz Purchase"
        : "Renewal Packages Purchase",
      event_label: "(not set)",
      event_source: "Payment Gateway",
      ...options,
    }),
    "Click on 'Proceed to Payment' on confirm Payment page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Intent" : "Renewal Intent",
      event_label: "Proceed to Payment",
    }),
    "Click on 'Cancel' on confirm Payment page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Intent" : "Renewal Intent",
      event_label: "Cancel Payment",
    }),
    "Redirection to Payment Successful Page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Success" : "Renewal Success",
      event_label: "Successful Payment",
    }),
    "Click on 'Continue' at Payment Success Page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Success" : "Renewal Success",
      event_label: "Continue Payment Success Page",
    }),
    "Redirection to Payment Unsuccessful Page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz
        ? "Buy Unsuccessful"
        : "Renewal Unsuccessful",
      event_label: "Unsuccessful Payment",
    }),
    "Click on 'Try Again' at Payment Unsuccessful Page": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: options?.isCreditBrickz ? "Buy Intent" : "Renewal Intent",
      event_label: "Try Again Payment",
    }),
    "Click on Renewal Packages": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: "Renew Packages",
      event_label: "(not set)",
      ...options,
    }),
    "Click on 'Renew in Advance'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Renewal Intent",
      event_label: "Renew in Advance",
    }),
    "Click on 'Renew upon Expiry'": () => ({
      ...GA_BASE.paymentGateway,
      event_action: "Renewal Intent",
      event_label: "Renew upon Expiry",
    }),
    "Click on 'Download Payment Receipt'": (options) => ({
      ...GA_BASE.paymentGateway,
      event_action: "Download Receipt",
      event_label: "(not set)",
      ...options,
    }),
  },
  areaCondoSpecialist: {
    "Click on 'Book Specialist'": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "View Book Specialist",
      event_label: "Book Specialist",
    }),
    "Click on 'Book Now'": (options) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "View Book Specialist",
      event_label: options?.isCondo
        ? "Book Condo Specialist"
        : "Book Area Specialist",
      ...options,
    }),
    "Click on 'Area Specialist' on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "View Area Specialist",
      event_label: "Area Specialist",
    }),
    "Click on 'Condo Specialist' on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "View Condo Specialist",
      event_label: "Condo Specialist",
    }),
    "Click on 'Redeem' on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Redeem Intent",
      event_label: "Redeem",
    }),
    "Click on 'Extend' on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Extend Intent",
      event_label: "Extend",
    }),
    "Click on 'Area Specialist' on Book Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Book Area Specialist",
      event_label: "Area Specialist",
    }),
    "Click on 'Condo Specialist' on Book Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Book Condo Specialist",
      event_label: "Condo Specialist",
    }),
    "Click on 'Book now' on Area/Condo Specialist": (options) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Book Intent",
      event_label: options?.isCondo
        ? "Book Condo Specialist"
        : "Book Area Specialist",
    }),
    "Click on 'Cancel' on Area/Condo Specialist": (options) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Book Cancel",
      event_label: options?.isCondo
        ? `Condo Specialist | ${options?.areaCondoName || "not set"}`
        : `Area Specialist | ${options?.areaCondoName || "not set"}`,
    }),
    "Click on 'Confirm' during booking on Area/Condo Specialist": (
      options
    ) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Book Success",
      event_label: options?.isCondo
        ? `Condo Specialist | ${options?.areaCondoName || "not set"}`
        : `Area Specialist | ${options?.areaCondoName || "not set"}`,
    }),
    "Click on 'Confirm upgrade' during redeem on Area/Condo Specialist": (
      options
    ) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Redeem Intent",
      event_label: "Confirm Redeem",
      ...options,
    }),
    "Click on 'Cancel' during redeem on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Redeem Cancel",
      event_label: "Cancel Redeem",
    }),
    "Click on 'Later' during redeem on Area/Condo Specialist": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Redeem Later",
      event_label: "Later Redeem",
    }),
    "On success redeem upgrade": () => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Redeem Success",
      event_label: "Success Redeem",
    }),
    "Select duration month & click 'Confirm extend'": (options) => ({
      ...GA_BASE.areaCondoSpecialist,
      event_action: "Extend Success",
      event_label: "(not set)",
      ...options,
    }),
  },
  leadSearch: {
    "Trigger on Search via Text Field (Auto Suggest Keyword)": (options) => ({
      ...GA_BASE.leadSearch,
      ...options,
      event_label: "Auto Suggest Keyword",
    }),
    "Trigger on Search via Delete Field": (options) => ({
      ...GA_BASE.leadSearch,
      ...options,
      event_label: "Remove Keyword",
    }),
  },
  leadFilter: {
    'Filter "Lead Quality"': (options) => ({
      ...GA_BASE.leadFilter,
      ...options,
      event_label: "On Click Lead Quality Dropdown Menu",
    }),
    'Filter "Lead Type"': (options) => ({
      ...GA_BASE.leadFilter,
      ...options,
      event_label: "On Click Lead Type Dropdown Menu",
    }),
    'Filter "Date"': (options) => ({
      ...GA_BASE.leadFilter,
      ...options,
      event_label: "On Filter Date Range",
    }),
    'Click on "Clear"': (options) => ({
      ...GA_BASE.leadFilter,
      ...options,
      event_label: "Remove All Lead Filter",
    }),
  },
  leadNavigation: {
    'Click "View Older Leads"': () => ({
      ...GA_BASE.leadNavigation,
      event_label: "On Click View Older Leads",
    }),
    'Click "Unread Toggle on"': (options) => ({
      ...GA_BASE.leadNavigation,
      event_label: "(not set)",
      ...options,
    }),
    "Click Lead Details Card": (options) => ({
      ...GA_BASE.leadNavigation,
      ...options,
      event_label: "On Click Lead Details",
    }),
    'Click "View Listing"': (options) => ({
      ...GA_BASE.leadNavigation,
      ...options,
      event_label: "On Click View Listing",
    }),
    "Click CTA from Lead Details": (options) => ({
      ...GA_BASE.leadNavigation,
      event_label: "(not set)",
      ...options,
    }),
    "Click on View more/View less": (options) => ({
      ...GA_BASE.leadNavigation,
      event_label: "(not set)",
      ...options,
    }),
    'Click on "feedback"': (options) => ({
      ...GA_BASE.leadNavigation,
      ...options,
      event_label: "On Click Feedback",
    }),
    "Back to Lead Management": () => ({
      ...GA_BASE.leadNavigation,
      event_label: "On Click Back To Lead Management",
    }),
  },
};

export const GA_ACTIONS: {
  [Section in string]: { [Action in MenuItemType["key"]]?: string };
} = {
  navigation: {
    dashboard: "Click on Dashboard",
    "listings-management": "Click on 'Listings Management'",
    "scheduled-manager": "Click on 'Scheduled Readvertising Manager'",
    watermark: "Click on 'Watermark Settings'",
    reportings: "Click on 'Agent Listing Report'",
    "market-analytics": "Click on Market Analytics",
    leads: "Click on 'Leads'",
    agent: "Header Tap on My Profile",
    subscriptions: "Header Tap on Subscriptions",
    team: "Header Tap on My Team",
    management: "Header Tap on Agency/Branch management",
    setting: "Header Tap on Account Settings",
    allocations: "Header Tap on Allocations",
    "log-out": "Header Tap on Log Out",
    "en-GB": "Header Tap on Change Language",
    "zh-HK": "Header Tap on Change Language",
    "zh-CN": "Header Tap on Change Language",
    "open-consumer-page-sf": "Link to consumer site SF",
    "open-consumer-page-my": "Link to consumer site MY",
    enquiry: "Header Tap on CC Enquiry",
    "search-property": "Click on 'Search Properties'",
    "property-wanted": "Click on 'Property Wanted'",
    "fsbo-alerts": "Click on 'FSBO Alerts'",
    "iq-agent": "Link to Home Report",
    brickz: "Link to Brickz",
    "credit-brickz": "Click on 'Buy'",
    "payment-history": "Header Tap on 'Payment History'",
    areaCondoSpecialistSelfServe:
      "Click on 'Area Condo Specialist' at Listing Header",
  },
};
